// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__w1Rzc","name":"ConsentHeader_name__3Z9df","birthday":"ConsentHeader_birthday__NoIuv","skeleton":"ConsentHeader_skeleton__2_tfF"};